/**
 * Masks an email address for display (e.g., "j***n@example.com")
 * @param email - The email address to mask
 * @returns The masked email or "email" if invalid
 */
export const maskEmail = (email: string | undefined | null): string => {
  if (!email) {
    return 'email';
  }

  const bits = email.split('@');
  if (bits.length < 2) {
    return 'email';
  }

  const domain = bits[1];
  const un = bits[0]?.split('') || [];
  const firstChar = un.shift();
  const lastChar = un.pop();
  const stars = Array(un.length).join('*');

  return `${firstChar}${stars}${lastChar}@${domain}`;
};

/**
 * Sets masked email text on all elements matching the selector within a container
 * @param container - The parent element to search within
 * @param email - The email address to mask
 * @param selector - CSS selector for elements to update (default: '[hekate-data="email"]')
 */
export const setMaskedEmailInElements = (
  container: HTMLElement | null,
  email: string | undefined | null,
  selector = '[hekate-data="email"]'
): void => {
  const maskedEmail = maskEmail(email);
  container?.querySelectorAll(selector).forEach((elm) => {
    elm.textContent = maskedEmail;
  });
};
